export const Roles = {
  ADMIN: 'pg_admin',
  MERCHANT: 'merchant',
  BAS_MERCHANT_VIEW: 'bas_merchant_view',
  MULTI_MERCHANT_VIEW: 'bas_multi_merchant_view',
} as const;

export const hasRole = (userRoles: string[] | undefined, role: string): boolean =>
  !!userRoles && userRoles.includes(role);

export const isMultiMerchantView = (userRoles: string[] | undefined): boolean =>
  hasRole(userRoles, Roles.MULTI_MERCHANT_VIEW);

export const isAnyMerchantRole = (userRoles: string[] | undefined): boolean =>
  hasRole(userRoles, Roles.MERCHANT) ||
  hasRole(userRoles, Roles.BAS_MERCHANT_VIEW) ||
  hasRole(userRoles, Roles.MULTI_MERCHANT_VIEW);
